import { gql } from '@apollo/client';

// ========== QUERIES ==========

export const GET_ADMIN_PARTNERS = gql`
  query AdminPartners($filter: AdminPartnerFilterInput, $page: Int, $pageSize: Int) {
    adminPartners(filter: $filter, page: $page, pageSize: $pageSize) {
      items {
        id
        name
        slug
        description
        type
        plan
        status
        isActive
        logoUrl
        displayMode
        createdAt
        enrollmentsCount
        transactionsCount
        totalRevenue
        locationsCount
        staffCount
      }
      total
      page
      pageSize
      totalPages
    }
  }
`;

export const GET_ADMIN_PARTNER = gql`
  query AdminPartner($id: String!) {
    adminPartner(id: $id) {
      id
      name
      slug
      description
      type
      plan
      status
      isActive
      logoUrl
      palette
      displayMode
      customDomain
      walletConfig
      setupFeePaid
      apiKey
      webhookUrl
      webhookEvents
      typeConfig
      createdAt
      updatedAt
      enrollmentsCount
      transactionsCount
      totalRevenue
      locationsCount
      staffCount
    }
  }
`;

export const GET_ADMIN_PARTNER_STATS = gql`
  query AdminPartnerStats {
    adminPartnerStats {
      totalPartners
      pendingApproval
      activePartners
      suspendedPartners
      byType {
        type
        count
      }
      byPlan {
        plan
        count
      }
      totalEnrollments
      totalRevenue
      avgEnrollmentsPerPartner
    }
  }
`;

export const GET_ADMIN_CROSS_PARTNER_ANALYTICS = gql`
  query AdminCrossPartnerAnalytics($startDate: DateTime, $endDate: DateTime) {
    adminCrossPartnerAnalytics(startDate: $startDate, endDate: $endDate) {
      totalEnrollments
      totalTransactions
      totalRevenue
      totalPointsAwarded
      topPartnersByEnrollments {
        partnerId
        partnerName
        enrollments
        transactions
        revenue
        pointsAwarded
      }
      topPartnersByRevenue {
        partnerId
        partnerName
        enrollments
        transactions
        revenue
        pointsAwarded
      }
      enrollmentsOverTime {
        date
        count
      }
      revenueOverTime {
        date
        count
        amount
      }
    }
  }
`;

// ========== MUTATIONS ==========

export const APPROVE_PARTNER = gql`
  mutation AdminApprovePartner($partnerId: String!) {
    adminApprovePartner(partnerId: $partnerId) {
      id
      status
      isActive
    }
  }
`;

export const REJECT_PARTNER = gql`
  mutation AdminRejectPartner($partnerId: String!, $reason: String!) {
    adminRejectPartner(partnerId: $partnerId, reason: $reason) {
      id
      status
      isActive
    }
  }
`;

export const SUSPEND_PARTNER = gql`
  mutation AdminSuspendPartner($partnerId: String!, $reason: String!) {
    adminSuspendPartner(partnerId: $partnerId, reason: $reason) {
      id
      status
      isActive
    }
  }
`;

export const REACTIVATE_PARTNER = gql`
  mutation AdminReactivatePartner($partnerId: String!) {
    adminReactivatePartner(partnerId: $partnerId) {
      id
      status
      isActive
    }
  }
`;

// Porte ++ (ADR 0022, #1006/#1008) — provisionnement d'un Partner structuré (graphe complet
// + Account natif) via une mutation admin gardée (PARTNERS_WRITE).
export const PROVISION_PARTNER = gql`
  mutation AdminProvisionPartner($input: ProvisionPartnerGqlInput!) {
    adminProvisionPartner(input: $input) {
      partnerId
      ownerId
      accountId
      programId
      slug
    }
  }
`;
